import { IdealFirstDateOptionIdType } from '@/pages/Onboarding/options/IdealFirstDate/types';

import { IDEAL_FIRST_DATE_OPTIONS } from '../IDEAL_FIRST_DATE_OPTIONS';

export const getIdealFirstDateTitleById = (
  id: IdealFirstDateOptionIdType | null,
): string | null => {
  if (!id) return null;
  return (
    IDEAL_FIRST_DATE_OPTIONS.find((option) => option.id === id)?.title || null
  );
};

const DEFAULT: IdealFirstDateOptionIdType = 'rooftop_bar';
export const getIdealFirstDateIdByTitle = (
  title: string | null | undefined,
  withDefault = false,
): IdealFirstDateOptionIdType | null => {
  const id = IDEAL_FIRST_DATE_OPTIONS.find(
    (option) => option.title === title,
  )?.id;
  if (id) {
    return id;
  }
  if (withDefault) {
    return DEFAULT;
  }
  return null;
};
